import { ContextualSaveBar, Layout, Page } from "@shopify/polaris";
import { useRef, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useHistory, useParams } from "react-router";

import { getOneReservationType, updateOneReservationType } from "api";
import { useSnackbar } from "providers";
import { SharedForm } from "../SharedForm";

export default function RecordDetail(props) {
  const skipToContentRef = useRef(null);
  const { reservationTypeId } = useParams();

  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { toggleSnack } = useSnackbar();

  const queryOnsuccess = (response) => {
    const payload = {
      _id: response?._id || "",
      title: response?.title || "",
      isDetail: true,
      description: response?.description || "",
      active: response?.active || false,
      isSelectableEducator: response?.isSelectableEducator || false,
      isSelectableHorse: response?.isSelectableHorse || false,
      isCreatableOnlyAdmin: response?.isCreatableOnlyAdmin || false,
      isInEffectiveSeansTime: response?.isInEffectiveSeansTime || false,
      selectType: response?.selectType || "",
      seansTime: response?.seansTime === 0 ? 0 : response?.seansTime || "",
      maxSelectableSeans:
        response?.maxSelectableSeans === 0
          ? 0
          : response?.maxSelectableSeans || "",
    };
    setInitialValues(payload);
  };

  useQuery(
    ["packages", reservationTypeId],
    () => getOneReservationType(reservationTypeId),
    {
      onSuccess: queryOnsuccess,
    }
  );

  const patchMutation = useMutation(
    (payload) => updateOneReservationType(payload, reservationTypeId),
    {
      onSuccess: (response) => {
        toggleSnack({
          key: "reservationTypesUpdateuccess",
          message: "Rezervasyon türü başarıyla güncellenmiştir",
          active: true,
        });
      },
      onError: (error) => {
        toggleSnack({
          key: "reservationTypesUpdaterror",
          error: true,
          message: error?.response?.data?.message,
          active: true,
        });
      },
    }
  );

  return (
    <Page
      title="Kayıt Detay"
      narrowWidth={true}
      breadcrumbs={[{ content: "Rezervasyon türü", url: "/reservationTypes" }]}
    >
      <Layout>
        <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
        {initialValues && (
          <SharedForm
            initialValues={initialValues}
            isDetail={true}
            onSubmit={(values) => patchMutation.mutate(values)}
            savebarRender={(values) => (
              <Savebar {...values} isLoading={patchMutation.isLoading} />
            )}
          />
        )}
      </Layout>
    </Page>
  );
}

function Savebar({ handleSubmit, isLoading }) {
  const history = useHistory();
  return (
    <ContextualSaveBar
      saveAction={{
        onAction: handleSubmit,
        loading: isLoading,
        content: "Güncelle",
      }}
      discardAction={{
        onAction: () => history.push("/reservationTypes"),
        content: "Geri",
      }}
    />
  );
}
